import React, { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_CHECKOUT_API || '';

export function hasResumeToken() {
    try {
        return new URLSearchParams(window.location.search).has('resume');
    } catch {
        return false;
    }
}

function getResumeToken() {
    try {
        return new URLSearchParams(window.location.search).get('resume');
    } catch {
        return null;
    }
}

export default function ResumeHandler() {
    const [error, setError] = useState(null);

    useEffect(() => {
        const token = getResumeToken();
        if (!token) return;

        let cancelled = false;
        (async () => {
            try {
                const res = await fetch(`${API_BASE}/api/abandoned/resume/${encodeURIComponent(token)}`);
                if (!res.ok) throw new Error(`Resume fetch failed (${res.status})`);
                const data = await res.json();
                if (cancelled) return;

                const design = data && data.design ? data.design : {};
                const controllerId = design.controllerId;
                const savedBuild = design.savedBuild;
                const originalPath = design.originalPath || '/';
                const originalSearch = design.originalSearch || '';

                if (controllerId && savedBuild) {
                    try {
                        localStorage.setItem('cm_saved_build_' + controllerId, JSON.stringify(savedBuild));
                    } catch (err) {
                        console.warn('[resume] could not write saved build to localStorage:', err.message);
                    }
                }

                const target = originalPath + originalSearch;
                window.location.replace(target);
            } catch (err) {
                console.warn('[resume] failed:', err.message);
                if (!cancelled) {
                    setError(err.message);
                    setTimeout(() => window.location.replace('/'), 1500);
                }
            }
        })();

        return () => { cancelled = true; };
    }, []);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            background: '#0a0a0a',
            color: '#fff',
            fontFamily: 'system-ui, sans-serif',
        }}>
            <div style={{ marginBottom: 16, fontSize: 18 }}>
                {error ? 'Could not load your design — redirecting…' : 'Loading your saved design…'}
            </div>
            <div style={{
                width: 32,
                height: 32,
                border: '3px solid rgba(255,255,255,0.2)',
                borderTopColor: '#fff',
                borderRadius: '50%',
                animation: 'cm-spin 0.8s linear infinite',
            }} />
            <style>{`@keyframes cm-spin { to { transform: rotate(360deg); } }`}</style>
        </div>
    );
}
